import {
  ColumnConfig,
  ResourceAccessLevel,
  SearchFilter,
  SearchFilterDetailsFragment
} from 'generated/graphql';

export const STANDARD_VIEW_ID = 'standard-view-id';

export const isStandardView = (view: SearchFilterDetailsFragment) => view.id === STANDARD_VIEW_ID;

const getInternalFilters = () => {
  return [
    { enabled: true, key: 'search' },
    { enabled: true, key: 'project' },
    { enabled: true, key: 'status' },
    { enabled: true, key: 'projectManager' },
    { enabled: true, key: 'assignee' }
  ];
};

const getExternalFilters = () => {
  return [
    { enabled: true, key: 'search' },
    { enabled: true, key: 'status' },
    { enabled: true, key: 'submitterGroupName' },
    { enabled: true, key: 'xtmProjectName' },
    { enabled: true, key: 'project' },
    { enabled: true, key: 'createdBy' },
    { enabled: true, key: 'distributed' }
  ];
};

const getInternalColumnConfig = (): ColumnConfig => {
  return {
    id: true,
    deadline: true,
    status: true,
    source: true,
    issue: true,
    projectName: true,
    filename: true
  };
};

const getExternalColumnConfig = (): ColumnConfig => {
  return {
    id: true,
    status: true,
    source: true,
    issue: true,
    projectName: true,
    xtmProjectName: true,
    filename: true
  };
};

export const getFilters = (internal: boolean) => {
  if (internal) {
    return getInternalFilters();
  }
  return getExternalFilters();
};

export const getColumnConfig = (internal: boolean) => {
  return internal ? getInternalColumnConfig() : getExternalColumnConfig();
};

export const getStandardView = (internal: boolean): SearchFilter => {
  return {
    createdAt: null,
    updatedAt: null,
    favorite: false,
    isDefault: true,
    filters: getFilters(internal),
    id: STANDARD_VIEW_ID,
    name: 'Standard View',
    isSubscribed: false,
    user: {
      accessLevel: ResourceAccessLevel.INTERNAL,
      displayName: 'SAP',
      email: '-',
      firstName: 'SAP',
      id: '0',
      internal,
      lastName: '',
      suppliers: [],
      username: 'SAP'
    },
    columnConfig: getColumnConfig(internal)
  };
};
